
import { isNotBlank } from "../../util/StringUtils";

export default (ssn) => {
    let display = 'XXXXX';
    if (isNotBlank(ssn)) {
        display = display + ssn.substring(5);
    }
    return display;
};
